import React from "react";

export default function FooterBottom() {
  return (
    <div className="w-full flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-gray-200/50 text-xs text-gray-500">
      <div className="text-center md:text-left" data-testid="footer-copyright">
        © 2026 STUDLYF AI. All Rights Reserved.
      </div>
      <div className="text-center font-medium text-gray-400 hidden sm:block" data-testid="footer-audience">
        Made for Founders • Students • Agencies • Incubators • Investors
      </div>
      <div className="text-center font-medium text-gray-400 sm:hidden block" data-testid="footer-audience-mobile">
        Made for Founders & Creators
      </div>
      <div className="flex items-center gap-1.5" data-testid="footer-version">
        <span className="text-[10px] uppercase font-bold tracking-wider text-gray-400">Version</span>
        <span className="px-2 py-0.5 rounded-full border border-gray-200 bg-gray-50 text-gray-600 font-mono font-semibold">
          v1.0
        </span>
      </div>
    </div>
  );
}
